module.exports = __webpack_public_path__ + "static/media/speech_07.7a872db6.png";